export const BOOK_DEMO_HREF = '/book-demo';

export const PRICING_DEMO_HREF = '/book-demo?intent=pricing';

export const SALES_DEMO_HREF = '/?demo=sales';

export const MARKETING_DEMO_HREF = '/?demo=marketing';
